import { AccomodationDto } from "./accomodation.dto";

export class ContactDto {
   /*
   *
   */
    constructor(
      public id?: number,
      public whatsapp?: string,
      public telephoneNumber?: string,
      public mobileNumber?: string,
      public email?: string,
      public facebook?: string,
      public instagram ?: string,
      public youtube?: string,
      public tiktok ?: string,
      public website?: string,
      public airbnb ?: string,
      public booking?: string,
      public otherWebsites?: Map<string, string>,
      public accomodation?: AccomodationDto
    ){}
}